import { render, staticRenderFns } from "./ImageDetails.vue?vue&type=template&id=397c8ff6"
import script from "./ImageDetails.vue?vue&type=script&lang=js"
export * from "./ImageDetails.vue?vue&type=script&lang=js"
import style0 from "./ImageDetails.vue?vue&type=style&index=0&id=397c8ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports